function getMessage(field, args) {
  return `The ${field} field is invalid.`
}

function validate(value, args) {
  if (value) {
    // Assumption the format is MM-YYYY
    const splitArr = value.split('-')
    if (splitArr && splitArr.length === 2) {
      if (splitArr[0].length === 2 && splitArr[1].length === 4) {
        const month = Number(splitArr[0])
        const year = Number(splitArr[1])
        const currentDate = new Date()
        const currentMonth = currentDate.getMonth() + 1 // 0 - 11, need add 1
        if (month > 0 && month <= 12 && year >= currentDate.getFullYear() && year < 2100) {
          // Need check if exact year, has it expire
          if (year === currentDate.getFullYear() && month < currentMonth) {
            return false
          } else {
            // Consider it valid
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
